import React, { useState, useContext, useEffect, useRef } from "react";
import { ThemeContext } from "../../../../context/ThemeContext.js";
import { Link } from "react-router-dom";
import { FetchPostData } from "../Utils/PPFetchMockData.js";
import '../Styles/PPGridCenter.css'  
import {
  MoreButton,
  CloseButton,
} from "../../../UI-comp/ActionButtons.js";
import CommentsSection from "../../../common/Comment/CommentsSection.js";
import ShareButton from "../../../common/Actions/shareButton.js"
import LikeButton from "../../../common/Actions/likeButton.js"
import SuggestButton from "../../../common/Actions/suggestButton.js"
import MenuDropdown from "../../../UI-comp/ManuDropdown.js";
import Carousel from "../../../common/Carousel/Carousel.js";
import GridLayout from "../../../common/Grid/gridMode.js" 
import LightboxGallery from "../../../common/LightBox/lightBox.js";
import HorizontalScrollDisplay from "../../../common/HorizontalScroll/horizontalScroll.js";
import VerticalScroll from "../../../common/VerticalScroll/verticalScroll.js";
  
const PPGridCenterLayout = ({postid, mediaDisplayMode}) => {
    const [showOptions, setShowOptions] = useState(false);
    // const [activeTab, setActiveTab] = useState(pagetype);
    const [coverImage, setCoverImage] = useState("/assets/images/login_page_img2.jpg"); 
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [isPostOpen, setIsPostOpen] = useState(true);
    const { theme } = useContext(ThemeContext);
    const [postData, setPostData] = useState({ profiles: [] });
    const [advertises, setAdvertises] = useState([]);
    const scrollRef = useRef(null);
    const [newComment, setNewComment] = useState("");
    const commentBoxRef = useRef(null);
    const [residents, setResidents] = useState([]);

    useEffect(() => {
      const initialize = async () => {
        try {
          const data = await FetchPostData(postid);
          if (data) {
            setPostData(data);
          } else {
            console.warn("No user data fetched.");
          }
        } catch (err) {
          console.error("Error fetching user profiles:", err);
        }
      };
    
      initialize();
    }, []);    
    
    if (!postData) {
      return <p>Loading feed data...</p>;
    }    
  
    const handleMoreOptionClick = (index) => {
      setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
    };
  
    const handleOptionClick = (option, index) => {
      console.log(`Option "${option}" clicked for media index ${index}`);
      setOpenDropdownIndex(null);
    };
      
    const handleClose = () => setIsPostOpen(false);

    const postmenuItems = [
      { label: "Edit Post", action: (index) => handleOptionClick("Edit Post", index) },
      { label: "Save", action: (index) => handleOptionClick("Save", index) },
      { label: "Archive", action: (index) => handleOptionClick("Archive", index) },
      { label: "Delete Post", action: (index) => handleOptionClick("Delete Post", index) },
      { label: "Report abuse", action: (index) => handleOptionClick("Report abuse", index) },
    ];

    const handleAddComment = (profileId, postId) => {
      if (newComment.trim()) {
        onAddComment(profileId, postId, newComment.trim());
        setNewComment("");
      }
    };

    const onAddComment = (profileId, postId, commentText) => {
      const addedComment = {
        userId: "currentUser", // Replace with actual logged-in user
        comment: commentText,
        timestamp: Date.now(),
        location: "Unknown",
      };

    setPostData((prevData) => {
      const updatedData = { ...prevData };
  
      updatedData.profiles = updatedData.profiles.map((profile) => {
        if (profile.profileId === profileId) {
          return {
            ...profile,
            posts: profile.posts.map((post) =>
              post.postId === postId
              ? { ...post, comments: [...(post.comments || []), addedComment] }
              : post
            ),
          };
        }
      return profile;
    });
  
    return updatedData;
  });

  setTimeout(() => {
    if (commentBoxRef.current) {
      commentBoxRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, 100);
  };

  return (
<div>
  {/* Feed Navigation (Single Post) */}
  <div className="lp-feed-container" style={{ marginTop: 40 }}>
    {postData && (
      <div key={postData.postId} className="lp-post-card">
        {/* User Header */}
        <div className="lp-user-container">
          <div style={{ width: 40, height: 40, marginLeft: 10, marginTop: 10 }}>
            <img
              src={postData.userimage || "/assets/default-profile.jpg"}
              alt="Profile"
              className="lp-profile-image"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          </div>
          <div>
            <p className="text-header" style={{ marginLeft: 10, marginTop: 20 }}>
            <Link 
              to={`/user-account/${postData.userId}`} 
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {postData.userId}
            </Link>
            </p>
          </div>
        </div>

        {/* Post Header */}
        <div style={{ display: "flex", flexDirection: "row", height: 60 }}>
          <div className="lp-feed-header" style={{ marginTop: 10 }}>
            <p className="text-label" style={{ marginLeft: 10 }}>
              <Link
                  to={`/location-page/${postData.location}`}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  #{postData.location}
                </Link>              
              , {new Date(postData.timestamp).toLocaleString()}
            </p>
          </div>
        </div>

        {/* Post Description & Media */}
        <div className="lp-feed-media" style={{ marginTop: 10 }}>
          <p className="text-label" style={{ marginLeft: 10, marginTop: -15 }}>
            {postData.descriptions}
          </p>

          {Array.isArray(postData.medias) && postData.medias.length > 0 && (
            <>
              {mediaDisplayMode === "slideshow" ? (
                <Carousel items={postData.medias} />
              ) : mediaDisplayMode === "lightbox" ? (
                <LightboxGallery mediaFiles={postData.medias} />
              ) : mediaDisplayMode === "horizontal-scroll" ? (
                <HorizontalScrollDisplay medias={postData.medias} />
              ) : mediaDisplayMode === "vertical-scroll" ? (
                <VerticalScroll medias={postData.medias} />
              ) : (
                <GridLayout mediaFiles={postData.medias} />
              )}
            </>
          )}
        </div>

        {/* Post Actions */}
        <div style={{ display: "flex", justifyContent: "space-between", gap: "20px" }}>
          <div
            className="lp-post-stats-left"
            style={{ display: "flex", flexDirection: "row", gap: 50 }}
          >
            <LikeButton /> <ShareButton /> <SuggestButton />
          </div>
          <div className="lp-post-stats-right">
            <span
              className="text-label"
              style={{
                fontSize: 18,
                marginRight: 10,
                color: "white",
                fontWeight: "normal",
              }}
            >
              ❤️ {postData.nlikes || 0} Likes &nbsp; | &nbsp; 🔁 {postData.nshares || 0} Shares
            </span>
          </div>
        </div>

        {/* Comments */}
        <div className="feed-comments">
          <p
            className="text-header"
            style={{ fontWeight: "normal", marginTop: "10px" }}
          >
            Comments:
          </p>
          <div className="comments-container">
            {Array.isArray(postData.comments) && postData.comments.length > 0 ? (
              postData.comments.map((comment, index) => (
                <div
                  key={index}
                  style={{
                    marginLeft: 10,
                    marginBottom: 10,
                    display: "flex",
                    flexDirection: "row",
                  }}
                  ref={index === postData.comments.length - 1 ? commentBoxRef : null}
                >
                  <p className="text-label" style={{ fontWeight: "bold" }}>
                    {comment.userId}
                  </p>
                  <p className="text-label" style={{ fontWeight: "normal" }}>
                    : {comment.comment} - (
                    {new Date(comment.timestamp).toLocaleString()})
                  </p>
                </div>
              ))
            ) : (
              <p className="text-label">No comments yet.</p>
            )}
          </div>
          <div className="lp-add-comment">
            <input
              type="text"
              value={newComment}
              placeholder="Add a comment..."
              onChange={(e) => setNewComment(e.target.value)}
              className="text-label"
              style={{
                marginLeft: -10,
                background: "rgb(196, 185, 185)",
                color: "darkgray",
              }}
            />
            <button
              onClick={() => handleAddComment(postData.postId)}
              className="lp-add-comment-button"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
</div>
  );
};

export default PPGridCenterLayout;